import { Box, Modal } from "@mui/material";
import { useState } from "react";
import FortuneWheel from "./CustomWheel";
import { Link } from "react-router-dom";

const CarouselModal = ({
  showModal,
  handleShowModal,
  wheelItems,
  check_last_spin,
}) => {
  const [state, setState] = useState({
    spin: false,
    wheelEnlarged: false,
    showInfo: true,
    showAward: false,
    isWinner: false,
    award_code: "",
    award: "",
    winIndex: 0,
    winDeg: 0,
    showInfoModal: false,
  });
  const [winType, setWinType] = useState({ type: "", prize: "" });

  const handleImages = (index) => {
    const images = [
      "/assets/wheel-icon/bag-money.svg",
      "/assets/wheel-icon/gift.svg",
      "/assets/wheel-icon/golden-gif.svg",
    ];

    return images[[index % 3]];
  };

  const copyToClipboard = () => {
    navigator.clipboard?.writeText(state.award_code);
  };

  const handleSpin = () => {
    setState((prevState) => ({
      ...prevState,
      spin: true,
      wheelEnlarged: true,
      showInfo: false,
    }));
  };

  const setCustomState = (newState) => {
    setState((perv) => ({ ...perv, ...newState }));
  };

  return (
    <Modal
      open={showModal}
      onClose={handleShowModal}
      className={"carouselModal"}
    >
      <>
        <Modal
          open={state.showInfoModal}
          onClose={() => {
            setState((perv) => ({ ...perv, showInfoModal: false }));
          }}
        >
          <Box className={"modal"}>
            <span>
              روزانه می توانید از گردونه شانس کاچار کد تخفیف و جوایز مختلف
              دریافت کنید. برای استفاده از گردونه فقط کافیست در وبسایت کاچارثبت
              نام کرده و چرخونک را بچرخانید.
            </span>
            <button
              onClick={() =>
                setState((perv) => ({ ...perv, showInfoModal: false }))
              }
            >
              متوجه شدم
            </button>
          </Box>
        </Modal>
        <video id="background-video" preload="auto" autoPlay loop muted>
          <source src="public/assets/videos/carousel-bg.mp4" type="video/mp4" />
        </video>
        <div className={"topBar"}>
          <button
            className={"top"}
            onClick={() => {
              setState((perv) => ({ ...perv, showInfoModal: true }));
            }}
          >
            <i className="icon-info-circle" />
          </button>

          <Link to="customerClub">
            <a className={"top"}>
              <i className="fa fa-award-simple" />
            </a>
          </Link>
        </div>
        <div className={`${"modalCarousel"} `}>
          <FortuneWheel
            setCustomState={setCustomState}
            giftsList={wheelItems.data.map((g, index) => ({
              id: g.id,
              title: g.title,
              image: handleImages(index),
            }))}
            spin={state.spin}
            win={state.award}
          />
          {state.showInfo ? (
            <div
              className={`${"carouselInfo"} ${
                state.wheelEnlarged ? "fadeOut" : "fadeIn"
              }`}
            >
              <h1>چرخونک روزانه</h1>
              <span>
                {check_last_spin.message
                  ? check_last_spin.message
                  : "شانس خودتان را برای برنده شدن یک جایزه امتحان کنید!"}
              </span>
              <button disabled={!check_last_spin.status} onClick={handleSpin}>
                شانستو امتحان کن
              </button>
            </div>
          ) : (
            state.showAward && (
              <div
                className={`${"carouselPrize"} ${
                  state.wheelEnlarged ? "fadeOut" : "fadeIn"
                }`}
              >
                <h1>چرخونک روزانه</h1>
                <div className={"prize"}>
                  {state.isWinner ? (
                    <>
                      <span>شما برنده</span>
                      <span className={"award"}>{state.award}</span>
                      <span>شدید!</span>
                    </>
                  ) : (
                    <span>
                      شما امروز شانس خود را امتحان کرده اید فردا دوباره مراجعه
                      کنید{" "}
                    </span>
                  )}
                </div>
                {state.isWinner &&
                  (winType.type === "point" ? (
                    <span>شما برنده {winType.prize} امتیاز شده اید</span>
                  ) : (
                    <button
                      className={"awardSection"}
                      onClick={copyToClipboard}
                    >
                      {winType.prize}
                      <i className="icon-copy" />
                    </button>
                  ))}
                <span>
                  کد تخفیف و دیگر جوایز کسب شده شما در باشگاه مشتریان قابل
                  مشاهده است
                </span>
                <div className={"buttonSection"}>
                  <Link to="customer-club">
                    <a className={"buttonClub"}>مشاهده باشگاه مشتریان</a>
                  </Link>
                  <a
                    onClick={() => window.location.reload()}
                    className={"buttonHome"}
                  >
                    بازگشت به خانه
                  </a>
                </div>
              </div>
            )
          )}
        </div>
      </>
    </Modal>
  );
};

export default CarouselModal;
